import { all, call, takeEvery, takeLatest, fork, put } from "redux-saga/effects";
import requestFunction from "../Utils/sagasGenericFunction";

import {
  UPDATE_PROFILE,
  FETCH_PROFILE,
  ADD_BANK,
  FETCH_ALL_BANKS,
  FETCH_WALLET_DETAILS,
  WITHDRAW_FUNDS,
  CANCEL_SUBSCRIPTION,
  CANCEL_TRIAL,
  REACTIVATE_SUBSCRIPTION,
  REACTIVATE_TRIAL,
  WEB_PURCHASE,
  FETCH_SUBSCRIPTION_DETAILS,
  CHANGE_PASSWORD,
  DELETE_ACCOUNT,
  UPLOAD_PROFILE_IMAGE,
  FETCH_LEADERBOARD_SUMMARY,
  FETCH_LEADERBOARD_CATEGORY,
  FETCH_ANALYTICS_OVERVIEW_SUMMARY,
  FETCH_ANALYTICS_READING_HISTORY,
  FETCH_ANALYTICS_READING_STREAK,
  FETCH_ANALYTICS_ACHIEVEMENTS,
  FETCH_ANALYTICS_INSIGHTS,
  FETCH_READING_PREFERENCES,
  UPDATE_READING_PREFERENCES,
} from "../ActionTypes";

import {
  updateProfile,
  getProfile,
  createBankDetails,
  getAllBanks,
  getWalletDetails,
  withdrawWalletFunds,
  cancelTrial,
  cancelSub,
  reactivateTrial,
  reactivateSub,
  makeWebPurchase,
  getSubscriptionDetails,
  changePass,
  deleteUserAccount,
  uploadUserProfileImage,
  getLeaderBoardSummary,
  getLeaderBoardCategory,
  getAnalyticsOverviewSummary,
  getAnalyticsReadingHistory,
  getAnalyticsReadingStreak,
  getAnalyticsAchievements,
  getAnalyticsInsights,
  getReadingPreferences,
  putReadingPreferences,
} from "../Api";

import {
  updateProfileSuccess,
  fetchProfileSuccess,
  addBankSuccess,
  fetchAllBanksSuccess,
  fetchWalletDetailsSuccess,
  withdrawFundsSuccess,
  cancelTrialSuccess,
  cancelSubscriptionSuccess,
  reactivateTrialSuccess,
  reactivateSubscriptionSuccess,
  webPurchaseSuccess,
  fetchSubscriptionDetailsSuccess,
  changePasswordSuccess,
  deleteAccountSuccess,
  uploadProfileImageSuccess,
  fetchLeaderBoardSummarySuccess,
  fetchLeaderBoardCategorySuccess,
  fetchLeaderBoardCategoryFailure,
  fetchAnalyticsOverviewSummarySuccess,
  fetchAnalyticsOverviewSummaryFailure,
  fetchAnalyticsReadingHistorySuccess,
  fetchAnalyticsReadingHistoryFailure,
  fetchAnalyticsReadingStreakSuccess,
  fetchAnalyticsReadingStreakFailure,
  fetchAnalyticsAchievementsSuccess,
  fetchAnalyticsAchievementsFailure,
  fetchAnalyticsInsightsSuccess,
  fetchAnalyticsInsightsFailure,
  fetchReadingPreferencesSuccess,
  fetchReadingPreferencesFailure,
  updateReadingPreferencesSuccess,
  updateReadingPreferencesFailure,
} from "../Actions";

export const updateProfileRequest = function* ({ payload }) {
  yield call(requestFunction, updateProfileSuccess, updateProfile, payload);
};

export const updateProfil = function* () {
  yield takeEvery(UPDATE_PROFILE, updateProfileRequest);
};

export const fetchProfileRequest = function* ({ payload }) {
  yield call(requestFunction, fetchProfileSuccess, getProfile, payload);
};

export const fetchProfil = function* () {
  yield takeEvery(FETCH_PROFILE, fetchProfileRequest);
};

export const addBankRequest = function* ({ payload }) {
  yield call(requestFunction, addBankSuccess, createBankDetails, payload);
};

export const addBankDetailss = function* () {
  yield takeEvery(ADD_BANK, addBankRequest);
};

export const fetchAllBankRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllBanksSuccess, getAllBanks, payload);
};

export const fetchBankss = function* () {
  yield takeEvery(FETCH_ALL_BANKS, fetchAllBankRequest);
};

export const fetchWalletRequest = function* ({ payload }) {
  yield call(requestFunction, fetchWalletDetailsSuccess, getWalletDetails, payload);
};

export const fetchWallett = function* () {
  yield takeEvery(FETCH_WALLET_DETAILS, fetchWalletRequest);
};

export const withdrawFundsRequest = function* ({ payload }) {
  yield call(requestFunction, withdrawFundsSuccess, withdrawWalletFunds, payload);
};

export const withdrawFundss = function* () {
  yield takeEvery(WITHDRAW_FUNDS, withdrawFundsRequest);
};

export const cancelTrailRequest = function* ({ payload }) {
  yield call(requestFunction, cancelTrialSuccess, cancelTrial, payload);
};

export const cancelTriiall = function* () {
  yield takeEvery(CANCEL_TRIAL, cancelTrailRequest);
};

export const cancelSubscriptionRequest = function* ({ payload }) {
  yield call(requestFunction, cancelSubscriptionSuccess, cancelSub, payload);
};

export const cancelSubs = function* () {
  yield takeEvery(CANCEL_SUBSCRIPTION, cancelSubscriptionRequest);
};

export const reactivateTrailRequest = function* ({ payload }) {
  yield call(requestFunction, reactivateTrialSuccess, reactivateTrial, payload);
};

export const reactivateTTriiall = function* () {
  yield takeEvery(REACTIVATE_TRIAL, reactivateTrailRequest);
};

export const reactivateSubscriptionRequest = function* ({ payload }) {
  yield call(requestFunction, reactivateSubscriptionSuccess, reactivateSub, payload);
};

export const reactivateSubs = function* () {
  yield takeEvery(REACTIVATE_SUBSCRIPTION, reactivateSubscriptionRequest);
};

export const webPurchaseRequest = function* ({ payload }) {
  yield call(requestFunction, webPurchaseSuccess, makeWebPurchase, payload);
};

export const webPurchasseee = function* () {
  yield takeEvery(WEB_PURCHASE, webPurchaseRequest);
};

export const fetchSubDetailsRequest = function* ({ payload }) {
  yield call(requestFunction, fetchSubscriptionDetailsSuccess, getSubscriptionDetails, payload);
};

export const fetchSubDetaillss = function* () {
  yield takeEvery(FETCH_SUBSCRIPTION_DETAILS, fetchSubDetailsRequest);
};

export const changePasswordRequest = function* ({ payload }) {
  yield call(requestFunction, changePasswordSuccess, changePass, payload);
};

export const changePasswordd = function* () {
  yield takeEvery(CHANGE_PASSWORD, changePasswordRequest);
};

export const deleteAccountRequest = function* ({ payload }) {
  yield call(requestFunction, deleteAccountSuccess, deleteUserAccount, payload);
};

export const deleteAcct = function* () {
  yield takeEvery(DELETE_ACCOUNT, deleteAccountRequest);
};

export const uploadProfileImageRequest = function* ({ payload }) {
  yield call(requestFunction, uploadProfileImageSuccess, uploadUserProfileImage, payload);
};

export const uploadProfImg = function* () {
  yield takeEvery(UPLOAD_PROFILE_IMAGE, uploadProfileImageRequest);
};

export const fetchLeaderBoardSummaryRequest = function* () {
  yield call(requestFunction, fetchLeaderBoardSummarySuccess, getLeaderBoardSummary);
};

export const fetchLeaderBoardSummy = function* () {
  yield takeEvery(FETCH_LEADERBOARD_SUMMARY, fetchLeaderBoardSummaryRequest);
};

export const fetchLeaderBoardCategoryRequest = function* ({ payload }) {
  try {
    const response = yield call(getLeaderBoardCategory, payload);

    if (typeof response !== "undefined") {
      yield put(fetchLeaderBoardCategorySuccess(response));
    } else {
      yield put(fetchLeaderBoardCategoryFailure());
    }
  } catch (ex) {
    yield put(fetchLeaderBoardCategoryFailure());
  }
};

export const fetchLeaderBoardCategoryData = function* () {
  yield takeLatest(FETCH_LEADERBOARD_CATEGORY, fetchLeaderBoardCategoryRequest);
};

export const fetchAnalyticsOverviewSummaryRequest = function* ({ payload }) {
  try {
    const response = yield call(getAnalyticsOverviewSummary, payload);

    if (typeof response !== "undefined") {
      yield put(fetchAnalyticsOverviewSummarySuccess(response));
    } else {
      yield put(fetchAnalyticsOverviewSummaryFailure());
    }
  } catch (ex) {
    yield put(fetchAnalyticsOverviewSummaryFailure());
  }
};

export const fetchAnalyticsOverview = function* () {
  yield takeLatest(FETCH_ANALYTICS_OVERVIEW_SUMMARY, fetchAnalyticsOverviewSummaryRequest);
};

export const fetchAnalyticsReadingHistoryRequest = function* ({ payload }) {
  try {
    const response = yield call(getAnalyticsReadingHistory, payload);

    if (typeof response !== "undefined") {
      yield put(fetchAnalyticsReadingHistorySuccess(response));
    } else {
      yield put(fetchAnalyticsReadingHistoryFailure());
    }
  } catch (ex) {
    yield put(fetchAnalyticsReadingHistoryFailure());
  }
};

export const fetchAnalyticsHistory = function* () {
  yield takeLatest(FETCH_ANALYTICS_READING_HISTORY, fetchAnalyticsReadingHistoryRequest);
};

export const fetchAnalyticsReadingStreakRequest = function* () {
  try {
    const response = yield call(getAnalyticsReadingStreak);

    if (typeof response !== "undefined") {
      yield put(fetchAnalyticsReadingStreakSuccess(response));
    } else {
      yield put(fetchAnalyticsReadingStreakFailure());
    }
  } catch (ex) {
    yield put(fetchAnalyticsReadingStreakFailure());
  }
};

export const fetchAnalyticsStreak = function* () {
  yield takeLatest(FETCH_ANALYTICS_READING_STREAK, fetchAnalyticsReadingStreakRequest);
};

export const fetchAnalyticsAchievementsRequest = function* () {
  try {
    const response = yield call(getAnalyticsAchievements);

    if (typeof response !== "undefined") {
      yield put(fetchAnalyticsAchievementsSuccess(response));
    } else {
      yield put(fetchAnalyticsAchievementsFailure());
    }
  } catch (ex) {
    yield put(fetchAnalyticsAchievementsFailure());
  }
};

export const fetchAnalyticsAchievementData = function* () {
  yield takeLatest(FETCH_ANALYTICS_ACHIEVEMENTS, fetchAnalyticsAchievementsRequest);
};

export const fetchAnalyticsInsightsRequest = function* ({ payload }) {
  try {
    const response = yield call(getAnalyticsInsights, payload);

    if (typeof response !== "undefined") {
      yield put(fetchAnalyticsInsightsSuccess(response));
    } else {
      yield put(fetchAnalyticsInsightsFailure());
    }
  } catch (ex) {
    yield put(fetchAnalyticsInsightsFailure());
  }
};

export const fetchAnalyticsInsightData = function* () {
  yield takeLatest(FETCH_ANALYTICS_INSIGHTS, fetchAnalyticsInsightsRequest);
};

export const fetchReadingPreferencesRequest = function* () {
  try {
    const response = yield call(getReadingPreferences);

    if (typeof response !== "undefined") {
      yield put(fetchReadingPreferencesSuccess(response));
    } else {
      yield put(fetchReadingPreferencesFailure());
    }
  } catch (ex) {
    yield put(fetchReadingPreferencesFailure());
  }
};

export const fetchReadingPreferenceData = function* () {
  yield takeLatest(FETCH_READING_PREFERENCES, fetchReadingPreferencesRequest);
};

export const updateReadingPreferencesRequest = function* ({ payload }) {
  try {
    const response = yield call(putReadingPreferences, payload);

    if (typeof response !== "undefined") {
      yield put(updateReadingPreferencesSuccess(response));
    } else {
      yield put(updateReadingPreferencesFailure());
    }
  } catch (ex) {
    yield put(updateReadingPreferencesFailure());
  }
};

export const updateReadingPreferenceData = function* () {
  yield takeLatest(UPDATE_READING_PREFERENCES, updateReadingPreferencesRequest);
};

export default function* rootSaga() {
  yield all([
    fork(updateProfil),
    fork(fetchProfil),
    fork(addBankDetailss),
    fork(fetchBankss),
    fork(fetchWallett),
    fork(withdrawFundss),
    fork(cancelTriiall),
    fork(cancelSubs),
    fork(reactivateTTriiall),
    fork(reactivateSubs),
    fork(webPurchasseee),
    fork(fetchSubDetaillss),
    fork(changePasswordd),
    fork(deleteAcct),
    fork(uploadProfImg),
    fork(fetchLeaderBoardSummy),
    fork(fetchLeaderBoardCategoryData),
    fork(fetchAnalyticsOverview),
    fork(fetchAnalyticsHistory),
    fork(fetchAnalyticsStreak),
    fork(fetchAnalyticsAchievementData),
    fork(fetchAnalyticsInsightData),
    fork(fetchReadingPreferenceData),
    fork(updateReadingPreferenceData),
  ]);
}
